import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable()
export class AppHttpClient {
  private baseUrl = `${environment.apiUrl}`;

  constructor(
    @Inject(HttpClient) private readonly http: HttpClient
  ) {}

  public get<T>(
    url: string,
    options?: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType?: 'json' | 'text' | any;
      withCredentials?: boolean;
      absolute?: boolean;
    },
  ): Observable<T> {
    const absolute = (options && options.absolute) || false;
    return this.http.get<T>(this.getFullUrl(url, absolute), options);
  }

  public post<T>(
    url: string,
    body: any,
    options?: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType?: 'json' | 'application/json' | any;
      withCredentials?: boolean;
      absolute?: boolean;
    },
  ): Observable<T> {
    const absolute = (options && options.absolute) || false;
    return this.http.post<T>(this.getFullUrl(url, absolute), body, options);
  }

  public delete<T>(
    url: string,
    options?: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
      absolute?: boolean;
    },
  ): Observable<T> {
    const absolute = (options && options.absolute) || false;
    return this.http.delete<T>(this.getFullUrl(url, absolute), options);
  }

  public put<T>(
    url: string,
    body: any,
    options?: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
      absolute?: boolean;
    },
  ): Observable<T> {
    const absolute = (options && options.absolute) || false;
    return this.http.put<T>(this.getFullUrl(url, absolute), body, options);
  }

  public patch<T>(
    url: string,
    body: any,
    options?: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
      absolute?: boolean;
    },
  ): Observable<T> {
    const absolute = (options && options.absolute) || false;
    return this.http.patch<T>(this.getFullUrl(url, absolute), body, options);
  }

  public getFullUrl(url: string, absolute: boolean): string {
    if (absolute) {
      return url;
    }

    return this.baseUrl + '/' + url;
  }
}
